import script from "./fundHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./fundHistory.vue?vue&type=script&setup=true&lang=ts"

import "./fundHistory.vue?vue&type=style&index=0&id=29505997&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29505997"]])

export default __exports__